import { createFileRoute } from '@tanstack/react-router';
import WelcomeModalPage from '@/features/home/welcome-modal';

export const Route = createFileRoute('/boas-vindas')({
  component: WelcomeModalPage,
});
